Ext.define('SA.lq.DatasetExportUsage', {
    constructor({datasetName, weeklyUsage, yearlyUsage}) {
        this.datasetName = datasetName;
        this.weeklyUsage = weeklyUsage;
        this.yearlyUsage = yearlyUsage;
    },

    getDatasetName() {
        return this.datasetName;
    },

    getWeeklyUsage() {
        return this.weeklyUsage;
    },

    getYearlyUsage() {
        return this.yearlyUsage;
    },

    proposedTotalUseExceedsLimits() {
        return this.getWeeklyUsage().getProposedTotalUsePercent() > 100
            || this.getYearlyUsage().getProposedTotalUsePercent() > 100;
    }
});